import styled from "@emotion/styled"
import { sizer } from "@ninjaone/utils"
import Text from "./Text"

const StyledTitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  grid-row-gap: ${sizer(1)};
`

const StyledTextRow = styled.div`
  color: ${({ theme }) => theme.color.text};
`

export const StyledTextGroup = styled.div`
  display: flex;
  > *:first-of-type {
    margin-right: ${sizer(2)};
  }
  align-items: center;
`

export default function TitleGroup({
  titleText,
  titleToken,
  TitleTailComponent,
  TitleComponent,
  descriptionText,
  descriptionToken,
  DescriptionComponent,
  SubheaderComponent,
  size,
  textWrap = true,
  color,
}) {
  return (
    <StyledTitleGroup>
      <StyledTextRow>
        {titleText && (
          <StyledTextGroup>
            <Text bold size={size === "sm" ? "md" : "lg"} {...{ textWrap, color }}>
              {titleText}
            </Text>
            {TitleTailComponent && <TitleTailComponent />}
          </StyledTextGroup>
        )}
        {titleToken && (
          <StyledTextGroup>
            <Text token={titleToken} bold size={size === "sm" ? "md" : "lg"} {...{ textWrap, color }} />
            {TitleTailComponent && <TitleTailComponent />}
          </StyledTextGroup>
        )}
        {TitleComponent && <TitleComponent />}
      </StyledTextRow>
      {(descriptionText || descriptionToken || DescriptionComponent) && (
        <StyledTextRow>
          {descriptionText && <Text {...{ textWrap, color }}>{descriptionText}</Text>}
          {descriptionToken && <Text token={descriptionToken} {...{ textWrap, color }} />}
          {DescriptionComponent && <DescriptionComponent />}
        </StyledTextRow>
      )}
      {SubheaderComponent && <SubheaderComponent />}
    </StyledTitleGroup>
  )
}
